// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  region: 'us-east-1',
  identityPoolId: 'us-east-1:fd297d77-f412-40d9-9c83-7d292b2a6cc1',
  userPoolId: 'us-east-1_u1IXzcpkZ',
  clientId: '48etp1qijpn2n9jcva3llbn0tk',
  rekognitionBucket: 'rekognition-pics',
  mandatorySignIn: true,
  albumName: 'usercontent',
  bucketRegion: 'us-east-1',
  accountId: '153888508172',

  ddbTableName: 'LoginTrail',

  cognito_idp_endpoint: '',
  cognito_identity_endpoint: '',
  sts_endpoint: '',
  dynamodb_endpoint: '',
  s3_endpoint: '',
  gaPropertyId:'UA-177963797-1',
  gtmContainerId:'GTM-W582BQZ',

  webSocket: 'wss://www.iposcentral-dev.com/web-profiles',
  deviceReportWebSocket: 'wss://www.iposcentral-dev.com/web-devices',
  deviceDashboardWebSocket: 'wss://www.iposcentral-dev.com/web-device-dashboard',
  stdPkgWebSocketURL: 'wss://www.iposcentral-dev.com/web-packagehandler',//IIT2-5802
  apiBaseUrl: 'https://www.iposcentral-dev.com',
  apiBaseUrlAsset: 'https://www.iposcentral-dev.com/asset-library-dev-original',
  //UAT-244
  uwpDefaultPackage: 'https://www.microsoft.com/en-us/p/ipos/9pdhj8lzwb77',
  //UAT-244 end
  pollFrequency: 20,
  gamingPollFrequency: 20,
  // For later reference
  // apiBaseUrl: 'https://www.iposcentral-qa.com',
  // apiBaseUrlAsset: 'https://www.iposcentral-qa.com/asset-library-qa-original'
  hidePartnerContent : false //Falg to show / hide partner content
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
